module.exports = __webpack_public_path__ + "static/media/estate-clarity-item-entry-userflow-2.dff15350.jpg";